const C = require("../constants");

const saleCanceled = (data) => {
    return {
        type: C.SALE_CANCELED,
        data
    }
};

export {saleCanceled};


// WEBPACK FOOTER //
// ./src/actions/SaleCanceledAction.js